var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoundOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6002_142)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4697 9.46973C17.7626 9.1768 18.2375 9.17675 18.5304 9.46961L20.0004 10.9393L21.4697 9.46973C21.7626 9.1768 22.2375 9.17675 22.5304 9.46961C22.8233 9.76247 22.8234 10.2373 22.5305 10.5303L21.0611 12L22.5305 13.4697C22.8234 13.7627 22.8233 14.2375 22.5304 14.5304C22.2375 14.8233 21.7626 14.8232 21.4697 14.5303L20.0004 13.0607L18.5304 14.5304C18.2375 14.8233 17.7626 14.8232 17.4697 14.5303C17.1769 14.2373 17.1769 13.7625 17.4698 13.4696L18.9398 12L17.4698 10.5304C17.1769 10.2375 17.1769 9.76266 17.4697 9.46973Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0367 3.39616C14.2002 2.62899 15.75 3.46348 15.75 4.85717V19.1429C15.75 20.5366 14.2002 21.3711 13.0367 20.6039L7.03762 16.6484C6.99677 16.6215 6.94892 16.6072 6.9 16.6072H4C2.48122 16.6072 1.25 15.3759 1.25 13.8572V10.1429C1.25 8.6241 2.48122 7.39288 4 7.39288H6.9C6.94892 7.39288 6.99677 7.37853 7.03762 7.3516L13.0367 3.39616ZM14.25 4.85717C14.25 4.65807 14.0286 4.53886 13.8624 4.64845L7.8633 8.60389C7.5774 8.7924 7.24246 8.89288 6.9 8.89288H4C3.30964 8.89288 2.75 9.45253 2.75 10.1429V13.8572C2.75 14.5475 3.30964 15.1072 4 15.1072H6.9C7.24246 15.1072 7.5774 15.2076 7.8633 15.3962L13.8624 19.3516C14.0286 19.4612 14.25 19.342 14.25 19.1429V4.85717Z",
    fill: "#BFBFBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6002_142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOff);
export default __webpack_public_path__ + "static/media/sound-off.a6e1da9ea010c79bff3aff7aea49969a.svg";
export { ForwardRef as ReactComponent };